import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import {AttributeValueHandler} from '@dcp/configurator';
import {DATE_FORMAT_ISO} from '@app/services/date/date.service';

@Injectable({
  providedIn: 'root',
})
export class TodayAttributeValueHandler implements AttributeValueHandler {
  readonly key = 'TODAY';
  readonly handle = () => formatDate(Date.now(), DATE_FORMAT_ISO, 'en-us');
}
